/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, isNumber, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getHealthCamps } from 'app/entities/health-camp/health-camp.reducer';
import { EntityType } from 'app/shared/model/enumerations/entity-type.model';
import { TransactionCategory } from 'app/shared/model/enumerations/transaction-category.model';
import { createEntity, getEntity, reset, updateEntity } from './health-camp-transaction.reducer';

export const HealthCampTransactionUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const healthCamps = useAppSelector(state => state.healthCamp.entities);
  const healthCampTransactionEntity = useAppSelector(state => state.healthCampTransaction.entity);
  const loading = useAppSelector(state => state.healthCampTransaction.loading);
  const updating = useAppSelector(state => state.healthCampTransaction.updating);
  const updateSuccess = useAppSelector(state => state.healthCampTransaction.updateSuccess);
  const entityTypeValues = Object.keys(EntityType);
  const transactionCategoryValues = Object.keys(TransactionCategory);

  const handleClose = () => {
    navigate(`/health-camp-transaction${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getHealthCamps({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.transactionDate !== undefined && typeof values.transactionDate !== 'number') {
      values.transactionDate = Number(values.transactionDate);
    }
    if (values.cursor !== undefined && typeof values.cursor !== 'number') {
      values.cursor = Number(values.cursor);
    }
    if (values.lastUpdated !== undefined && typeof values.lastUpdated !== 'number') {
      values.lastUpdated = Number(values.lastUpdated);
    }
    if (values.microSec !== undefined && typeof values.microSec !== 'number') {
      values.microSec = Number(values.microSec);
    }
    if (values.timestampEntry !== undefined && typeof values.timestampEntry !== 'number') {
      values.timestampEntry = Number(values.timestampEntry);
    }

    const entity = {
      ...healthCampTransactionEntity,
      ...values,
      camp: healthCamps.find(it => it.id.toString() === values.camp?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          organizerType: 'LAB',
          transactionType: 'DB',
          ...healthCampTransactionEntity,
          camp: healthCampTransactionEntity?.camp?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="tinyMedicRestApp.healthCampTransaction.home.createOrEditLabel" data-cy="HealthCampTransactionCreateUpdateHeading">
            <Translate contentKey="tinyMedicRestApp.healthCampTransaction.home.createOrEditLabel">
              Create or edit a HealthCampTransaction
            </Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="health-camp-transaction-id"
                  label={translate('tinyMedicRestApp.healthCampTransaction.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('tinyMedicRestApp.healthCampTransaction.transactionDate')}
                id="health-camp-transaction-transactionDate"
                name="transactionDate"
                data-cy="transactionDate"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.healthCampTransaction.organizerType')}
                id="health-camp-transaction-organizerType"
                name="organizerType"
                data-cy="organizerType"
                type="select"
              >
                {entityTypeValues.map(entityType => (
                  <option value={entityType} key={entityType}>
                    {translate(`tinyMedicRestApp.EntityType.${entityType}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                label={translate('tinyMedicRestApp.healthCampTransaction.organizerId')}
                id="health-camp-transaction-organizerId"
                name="organizerId"
                data-cy="organizerId"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.healthCampTransaction.transactionType')}
                id="health-camp-transaction-transactionType"
                name="transactionType"
                data-cy="transactionType"
                type="select"
              >
                {transactionCategoryValues.map(transactionCategory => (
                  <option value={transactionCategory} key={transactionCategory}>
                    {translate(`tinyMedicRestApp.TransactionCategory.${transactionCategory}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                label={translate('tinyMedicRestApp.healthCampTransaction.transactionId')}
                id="health-camp-transaction-transactionId"
                name="transactionId"
                data-cy="transactionId"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.healthCampTransaction.active')}
                id="health-camp-transaction-active"
                name="active"
                data-cy="active"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.healthCampTransaction.cursor')}
                id="health-camp-transaction-cursor"
                name="cursor"
                data-cy="cursor"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.healthCampTransaction.lastUpdated')}
                id="health-camp-transaction-lastUpdated"
                name="lastUpdated"
                data-cy="lastUpdated"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.healthCampTransaction.microSec')}
                id="health-camp-transaction-microSec"
                name="microSec"
                data-cy="microSec"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.healthCampTransaction.timestampEntry')}
                id="health-camp-transaction-timestampEntry"
                name="timestampEntry"
                data-cy="timestampEntry"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                id="health-camp-transaction-camp"
                name="camp"
                data-cy="camp"
                label={translate('tinyMedicRestApp.healthCampTransaction.camp')}
                type="select"
              >
                <option value="" key="0" />
                {healthCamps
                  ? healthCamps.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/health-camp-transaction" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default HealthCampTransactionUpdate;
